// extracted by mini-css-extract-plugin
export default {"item":"styles__item___s2dC+"};